// app/javascript/controllers/photo_id_validation_controller.js
import { Controller } from "@hotwired/stimulus"
import heic2any from "heic2any"

export default class extends Controller {
  static targets = ["input", "error"]

  connect() {
    // Read allowed types from HTML 'accept' attribute
    this.allowedTypes =
      this.inputTarget
        .getAttribute("accept")
        ?.split(",")
        .map((t) => t.trim()) || []

    this.inputTarget.addEventListener("change", () => this.validateFile())
  }

  validateFile() {
    const file = this.inputTarget.files[0]
    this.clearError()

    if (!file || file.size === 0) {
      this.showError("File is empty or corrupted.")
      this.inputTarget.value = null
      return
    }

    if (!this.allowedTypes.includes(file.type)) {
      this.showError(
        `File type not allowed. Allowed types: ${this.allowedTypes.join(", ")}`
      )
      this.inputTarget.value = null
      return
    }

    // HEIC/HEIF validation (conversion check)
    if (file.type === "image/heif" || file.type === "image/heic") {
      heic2any({ blob: file })
        .then(() => this.showSuccess())
        .catch(() => {
          this.showError(
            "Cannot process HEIC/HEIF image. File may be corrupted."
          )
          this.inputTarget.value = null
        })
      return
    }

    // Standard image validation
    const reader = new FileReader()
    reader.onload = (e) => {
      const img = new Image()
      img.onload = () => this.showSuccess()
      img.onerror = () => {
        this.showError("Cannot process image. File may be corrupted.")
        this.inputTarget.value = null
      }
      img.src = e.target.result
    }
    reader.readAsDataURL(file)
  }

  showError(message) {
    this.errorTarget.textContent = message
    this.inputTarget.classList.add("is-invalid")
  }

  clearError() {
    this.errorTarget.textContent = ""
    this.inputTarget.classList.remove("is-invalid")
  }

  showSuccess() {
    this.clearError()
  }
}
